// extracted by mini-css-extract-plugin
module.exports = {"tableItemList":"TableItemList_tableItemList__2metQ","tableItem":"TableItemList_tableItem__1K9za"};